// extracted by mini-css-extract-plugin
export default {"benefits":"instant-set_benefits__sZQrT"};